/**
 * Format file size in bytes to human readable format
 */
export function formatSize(bytes: number): string {
  if (bytes === 0) return '0 Bytes';
  
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}

/**
 * Format dimension value for display
 */
export function formatDimension(value: number): string {
  if (value < 0.1) {
    return value.toFixed(3);
  } else if (value < 1) {
    return value.toFixed(2);
  } else if (value < 10) {
    return value.toFixed(1);
  } else {
    return Math.round(value).toString();
  }
}

/**
 * Parse dimension string to number
 */
export function parseDimension(value: string): number {
  const parsed = parseFloat(value);
  return isNaN(parsed) ? 0 : Math.max(0, parsed);
} 